import { graphql } from "relay-runtime"

export const deMarkPatientAsPotentialDuplicateMutation = graphql`
  mutation deMarkPatientAsPotentialDuplicateMutation($input: De_markPatientAsPotentialDuplicateInput!) {
    markPatientAsPotentialDuplicate: de_markPatientAsPotentialDuplicate(input: $input) {
      boolean
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`
